import {
  Required,
  IsString,
  IsNumber,
  IsBoolean,
  DataValidator,
  transformKeys,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

interface SidebarFoldersParams {
  workspace_id: string;
  current_page?: number;
  page_size?: number;
  switch_workspace?: boolean;
}

interface SidebarFoldersProps {
  workspaceId: string;
  currentPage?: number;
  pageSize?: number;
  switchWorkspace?: boolean;
}

// 原始接口
interface SidebarFoldersResponse {
  current_num: number;
  total_page: number;
  total_folder: number;
  folders: {
    id: string;
    name: string;
    sort_order: number;
    project_num: number;
    is_uncategorized: boolean;
  }[];
}

// 嵌套对象类
class Folder {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Sort order cannot be empty")
  @IsNumber("Sort order must be a number")
  sortOrder: number;

  @Required("Project num cannot be empty")
  @IsNumber("Project num must be a number")
  projectNum: number;

  @Required("Is uncategorized cannot be empty")
  @IsBoolean("Is uncategorized must be a boolean")
  isUncategorized: boolean;

  @IsString("Created at must be a string")
  createdAt: string;

  @IsString("Latest video image must be a string")
  latestVideoImage?: string;
}

// 主数据类
export class SidebarFoldersData {
  @Required("Current num cannot be empty")
  @IsNumber("Current num must be a number")
  currentNum: number;

  @Required("Total page cannot be empty")
  @IsNumber("Total page must be a number")
  totalPage: number;

  @Required("Total folder cannot be empty")
  @IsNumber("Total folder must be a number")
  totalFolder: number;

  @Required("Folders cannot be empty")
  @IsArray("Folders must be an array")
  @ValidateNested(Folder)
  folders: Folder[];
}

const transformAndValidateSidebarFolders = (
  response: SidebarFoldersResponse
): SidebarFoldersData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, SidebarFoldersData);
  } catch (error) {
    console.error("Sidebar folders data validation failed:", error.message);
    throw error;
  }
};

// 获取文件夹下项目
export const sidebarFolders = async (props: SidebarFoldersProps): Promise<SidebarFoldersData> => {
  const params: SidebarFoldersParams = {
    workspace_id: props.workspaceId,
    current_page: props.currentPage,
    page_size: props.pageSize,
    switch_workspace: props.switchWorkspace,
  };
  const res = await api.post<SidebarFoldersResponse>("/sidebar/folders", params);
  const validatedData = transformAndValidateSidebarFolders(res.data);
  return validatedData;
};
